module.exports = __webpack_public_path__ + "static/img/headerBanner.535e0bb8.png";